<template>

  <div class="tab">
    <dl>
      <dd :class="{active:activeName==='first'}">
        <router-link :to="{name:'user_protocol'}" class="link">用户协议</router-link>
      </dd>
      <dd :class="{active:activeName==='second'}">
        <router-link :to="{name:'privacy_clauset'}" class="link">隐私条款</router-link>
      </dd>
      <!--<dd :class="{active:activeName==='third'}">-->
        <!--<router-link :to="{name:'terms_of_business_residence'}" class="link">商家入驻条款</router-link>-->
      <!--</dd>-->
    </dl>
  </div>
</template>

<script>
	export default {
		name: "banner",
    props:{
	    activeName:{
	    	type: String,
        default: ''
      },
    }
	}
</script>

<style lang="scss">
  .tab{
    height: 50px;
    background-color: #EDEEF0;
    dl{
      display: flex;
      height: 100%;
      justify-content: center;
      dd{
        position: relative;
        line-height: 50px;
        margin-right: 111px;
        font-size: 14px;
        .link{
          display: inline-block;
          color: #4B5062;
          width: 100%;
          height: 100%;
        }
      }
      dd.active::before{
        content: '';
        background-color: #ff733c;
        width: 24px;
        height: 2px;
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 0px;
        margin: 0 auto;
      }
      dd.active .link{
        color: #ff733c;
      }
      dd:hover::before{
        content: '';
        background-color: #ff733c;
        width: 24px;
        height: 2px;
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 0px;
        margin: 0 auto;
      }
    }
  }
</style>
